import { gql } from 'apollo-boost'

export const GET_NOTIFICATIONS = gql`
  query GetNotifications {
    listUserNotifications {
      id
      createdAt
      updatedAt
      group
      type
      date
    }
  }
`
